import React from 'react'
import { Link, graphql } from 'gatsby'
import { Button, Info } from '../../ui'
import EssentialsInfos from './essentialInfos/essentialsInfos'
import HeaderMedia from '../../ui/headerMedia'
import Logo from '../../ui/logo'
import { Offer } from './mapper'
import ButtonColor from '../../ui/buttonColor'
import { useApplyStore } from '../../../stores/ui/applyStore'

type OfferHeaderProps = {
  infos: Offer
  careerSite: boolean
  reference?: React.RefObject<HTMLDivElement>
}

const OfferHeader: React.FC<OfferHeaderProps> = ({
  infos,
  careerSite,
  reference,
}) => {
  const firmSlug = infos?.office?.firm?.slug ?? null
  let firmUrl = ''
  if (firmSlug) {
    firmUrl = `/cabinets/${firmSlug}`
  }
  if (careerSite) {
    firmUrl = `/${firmSlug}`
  }
  const positionFilled = infos?.positionFilled ?? false
  const height = careerSite ? 'lg:top-[250px]' : 'lg:top-[320px]'

  const openApplicationFormModal = useApplyStore(
    (state) => state.openApplicationFormModal,
  )

  return (
    <div ref={reference}>
      <div className="container mb-8 lg:mb-10">
        <div className="relative">
          <HeaderMedia headerMediaImage={infos.office.firm.header} />
        </div>
        <div
          className={`absolute top-36 right-0 left-0 text-center text-white w-screen
        ${height} xl:w-[1115px] lg:w-[950px] lg:mx-auto 2xl:w-[1300px]`}
        >
          <div className="flex flex-col items-center lg:flex-row lg:items-start">
            <Link
              className="shadow w-24 h-24 bg-white rounded-xl p-6 flex items-center justify-center overflow-hidden
            lg:top-[25px] lg:w-36 lg:h-36"
              to={firmUrl}
            >
              <Logo
                image={infos.office.firm.logo}
                alt={infos?.office?.firm?.name || null}
              />
            </Link>
            <div className="flex flex-col items-center h-40 justify-evenly mt-36 lg:items-start lg:mt-0 lg:justify-normal">
              <h1 className="sr-only">
                {infos?.title} - {infos.office.firm.name}
              </h1>
              <h2 className="mx-4 text-2xl font-bold lg:mx-6">
                {infos.office.firm.name}
              </h2>
              <h3 className="mx-4 text-xl lg:mb-2 lg:mt-2 lg:mx-6 md:text-left">
                {infos?.title}
              </h3>
              {infos?.office.city && (
                <div className="lg:ml-5">
                  <Info
                    icon="pin"
                    color="white"
                    value={infos.office.city}
                    size="sm"
                  />
                </div>
              )}
              <div className="mt-3 text-sm font-semibold text-gray-500 lg:ml-6">
                {infos?.publishedDate}
              </div>
              <div className="lg:hidden">
                <EssentialsInfos
                  data={infos}
                  color="white"
                  bgColor="transparent"
                />
              </div>
              <div className="mt-8 lg:hidden">
                {!positionFilled &&
                  (careerSite && infos.office.firm.colorCareerSite ? (
                    <ButtonColor
                      label="Postuler"
                      invert
                      color={infos.office.firm.colorCareerSite || 'null'}
                      onClick={() =>
                        openApplicationFormModal({
                          offerId: infos.id as string,
                          isCareerSiteApply: careerSite,
                          colorCareerSite:
                            infos.office.firm.colorCareerSite || undefined,
                        })
                      }
                    />
                  ) : (
                    <Button
                      label="Postuler"
                      invert
                      color="primary"
                      onClick={() =>
                        openApplicationFormModal({
                          offerId: infos.id as string,
                        })
                      }
                    />
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OfferHeader

export const query = graphql`
  fragment OfferHeader on STRAPI_ACCOUNTING_OFFER {
    title
    publishedAt(locale: "")
    createdAt(locale: "")
    updatedAt(locale: "")
    positionFilled
    office {
      city
      postalCode
      firm {
        name
        slug
        logo {
          localFile {
            childImageSharp {
              gatsbyImageData
            }
            extension
            url
          }
        }
        header {
          url
          localFile {
            childImageSharp {
              gatsbyImageData(formats: WEBP)
            }
          }
        }
      }
    }
  }
`
